import React from "react"
import {Wrapper, ImageFrames} from "./styled"
const Question = (props) => (
  <Wrapper>
    <ImageFrames />
  </Wrapper>
)

export default Question